'use client'

import { useEffect } from 'react'
import { setInstallPrompt, type InstallPromptEvent } from '@/lib/pwa'

// Регистрирует service worker (public/sw.js) и запоминает предложение
// установки. В dev не регистрируем: воркер пережил бы перезапуски next dev и
// мешал горячей перезагрузке.
export function PwaRegister() {
  useEffect(() => {
    const onPrompt = (e: Event) => {
      // Не даём браузеру показать свою плашку — предложим сами в настройках.
      e.preventDefault()
      setInstallPrompt(e as InstallPromptEvent)
    }
    const onInstalled = () => setInstallPrompt(null)
    window.addEventListener('beforeinstallprompt', onPrompt)
    window.addEventListener('appinstalled', onInstalled)

    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' }).catch(() => {})
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt)
      window.removeEventListener('appinstalled', onInstalled)
    }
  }, [])

  return null
}
